import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yhwcgsa83p: FaireBrandEntity = {
  token: "b_yhwcgsa83p",
  type: "brand",
  name: "Cannizzaro Sauces",
  avatarUrl:
    "https://cdn.faire.com/fastly/3c47a61262b48f57bc7f7ff0ccb5ea7d89d5475da0615c3c2487527b03897e3e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/655d8d629cddb136fa52662bb608580078cd09d7ff816dc60687a368d9e91ed8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3c47a61262b48f57bc7f7ff0ccb5ea7d89d5475da0615c3c2487527b03897e3e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/655d8d629cddb136fa52662bb608580078cd09d7ff816dc60687a368d9e91ed8.png",
  location: "Charlotte, NC, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Melanie Cannizzaro-Tritten and her husband Andy decided it was time to share her marinara sauce with the world, not just friends and family who have been enjoying it for years. Born in Rochester,  NY, Melanie’s Italian heritage and culinary expertise brought her to making her famed marinara and a family of enjoyable and healthy recipes and sauces as well. Welcome to Cannizzaro Famiglia.  Cannizzaro Famiglia takes the old world Italian traditions to your kitchen through authentic sauce creations.\n\nUsing only the freshest ingredients and combining them with a lot of hard work and love, Cannizzaro Famiglia sauces come alive at your dinner table.  Hand Crafted in Charlotte, North Carolina, Cannizzaro Famiglia is producing a Marinara, Mushroom Marinara, Vodka, Arrabbiata, and a Vegan Marinara sauce.  The newest addition to the family is the Piccata Sauce!\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:07.833Z",
    importedBy: "entity-db-cli",
  },
};
